import { Check } from 'lucide-react';
import { cn } from '@/lib/utils';

/**
 * The scratchpad's 16px todo checkbox (the app has no Checkbox primitive — see
 * CheckboxPill's note). Done fills with the --ok green + white check per the design.
 * @param {{ checked: boolean, onToggle?: (next: boolean) => void, disabled?: boolean, label?: string }} props
 */
function NotesCheckbox({ checked, onToggle, disabled, label }) {
  return (
    <button
      type="button"
      role="checkbox"
      aria-checked={checked}
      aria-label={label}
      disabled={disabled}
      onClick={() => onToggle?.(!checked)}
      className={cn(
        'mt-px flex size-4 shrink-0 items-center justify-center rounded-[5px] border-[1.5px] transition-colors',
        checked
          ? 'border-ok bg-ok text-white'
          : 'border-muted-foreground bg-transparent hover:border-foreground',
        disabled && 'cursor-not-allowed opacity-60',
      )}
    >
      {checked ? <Check className="size-2.5" strokeWidth={3.5} aria-hidden /> : null}
    </button>
  );
}

export default NotesCheckbox;
